import { TimelineMax } from 'gsap/gsap-core.js';;
import { ScrollTrigger, Flip, gsap } from '../globals/gsap.js';

class Mosaic {
  stateClasses = {
    scatter : 'mosaic--scatter',
    zoom : 'mosaic--zoom',
  }

  constructor($el) {
    this.$el = $el;
    this.$pictureRow = this.$el.find('[data-mosaic="picture-row"]');
    this.$pictures = this.$pictureRow.find('[data-mosaic="picture"]');
    this.$top = this.$el.find('[data-picture="top"]');
    this.$left = this.$el.find('[data-picture="left"]');
    this.$right = this.$el.find('[data-picture="right"]');
    this.$bottom = this.$el.find('[data-picture="bottom"]');
    this.$bottomImg = this.$bottom.find('*').first();
    this.$pictureContainer = this.$pictureRow.find('[data-mosaic="picture-container"]');
    this.$fadeIn = this.$el.find('[data-mosaic="fade-in"]');

    this.$text = this.$el.find('[data-mosaic="text"]');

    // refresh scrolltrigger if this.$bottomImg is a video and it's loaded
    // console.log(this);

    // this.$bottom can be a video, trigger event when it's loaded
    this.$bottom.on('loadeddata', () => {
      ScrollTrigger.refresh();
    });




    this.initTimeline();
  }

  initTimeline = () => {

    this.tl = new TimelineMax({
      scrollTrigger: {
        trigger: this.$pictureRow,
        start: "center center",
        end: '+=100%',
        scrub: true,
        markers: false,
        pin: this.$pictureRow,
      },
    });

    // scatter the images
    // tl.addLabel('scatter');
    this.tl.to(this.$top, {
      yPercent: -105,
      ease: 'none',
      duration: 1,
    });

    this.tl.to(this.$left, {
      xPercent: -105,
      ease: 'none',
      duration: 1,
    }, 0);

    this.tl.to(this.$right, {
      xPercent: 105,
      ease: 'none',
      duration: 1,
    }, 0);

    // scale the container
    this.tl.to(this.$pictureContainer, {
      scale: 1,
      ease: 'none',
      duration: 1,
    });

    this.tl.to(this.$bottomImg, {
      scale: 1,
      ease: 'none',
      duration: 1,
    }, '-=1');


    if(this.$text.length) {
      ScrollTrigger.create({
        trigger: this.$text,
        start: 'top bottom',
        end: 'top top',
        pin: this.$el,
        pinSpacing: true,
        markers: false,
        onLeave: () => {
          gsap.delayedCall(0.2, () => {
            gsap.utils.toArray(this.$fadeIn).forEach((el, i) => {
              gsap.to(el, {
                delay: i * 0.2,
                onStart: () => {
                  el.classList.add('in-view');
                }
              });
            });
          });
        },
      });
    }

  }
}

export default Mosaic;